import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Grid, {GridProps} from '@mui/material/Grid';
import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
   groupBox: {
      position: 'relative',
      padding: '8px'
   },
   groupBoxBorder: {border: '1px solid lightgray', borderRadius: 5},
   fullWidth: {
      width: '100%'
   },
   groupBoxText: {
      position: 'absolute',
      verticalAlign: 'middle',
      marginTop: '-20px',
      backgroundColor: 'inherit',
      width: 'fit-content'
   }
}));

export interface GridGroupBoxProps extends GridProps {
   children: React.ReactNode;
   label?: string;
   fullWidth?: boolean;
   style?: React.CSSProperties;
   className?: string;
   classNameLabel?: string;
   hideBorder?: boolean;
}
/**
 * Generar una caja con bordes para agrupar los componentes internos.
 */
function GridGroupBox({
   children,
   label,
   fullWidth,
   style,
   className,
   classNameLabel,
   hideBorder,
   ...other
}: GridGroupBoxProps) {
   const {classes, cx} = useStyles();
   return (
      <Grid
         container
         {...other}
         //sx={{position: 'relative', mt: 4}}
         style={style}
         className={cx(classes.groupBox, className, {
            [classes.fullWidth]: fullWidth,
            [classes.groupBoxBorder]: !hideBorder
         })}
      >
         <Typography className={cx(classes.groupBoxText, classNameLabel)}>{label}</Typography>
         {children}
      </Grid>
   );
}
GridGroupBox.propTypes = {
   /**
    * Texto ha mostrar sobre la caja de grupo.
    */
   label: PropTypes.string
};
export default GridGroupBox;
